import { LOGIN_TIME_STAMP, EXPIRED_TIME } from '@/constants';

const setStorage = (key, val) => {
	if (typeof val === 'object') {
		val = JSON.stringify(val);
	}
	localStorage.setItem(key, val);
};

const getStorage = (key) => {
	const data = localStorage.getItem(key);
	try {
		return JSON.parse(data);
	} catch (err) {
		return data;
	}
};

const removeStorage = (key) => {
	localStorage.removeItem(key);
};

const clearStorage = () => {
	localStorage.clear();
};

const getPlatform = () => {
	const userAgent = window.navigator.userAgent;
	return {
		isIos: /iPhone/i.test(userAgent) || /iPad/i.test(userAgent),
		isAndroid: /Android/i.test(userAgent),
	};
};

const setFirstInUrl = () => {
	if (!window.firstEntryUrl) {
		window.firstEntryUrl = window.location.href.split('#')[0];
	}
};

const getConfigUrl = () => {
	let url = '';
	if (getPlatform().isIos) {
		url = window.firstEntryUrl;
	} else {
		url = window.location.href.split('#')[0];
	}
	return url;
};

const getFileSize = (size) => {
	if (size === undefined || /\D/.test(size)) {
		return 'N/A';
	}

	function round(num, precision) {
		return (
			Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision)
		);
	}
	var boundary = Math.pow(1024, 4);
	// TB
	if (size > boundary) {
		return round(size / boundary, 1) + 'TB';
	}
	// GB
	if (size > (boundary /= 1024)) {
		return round(size / boundary, 1) + 'GB';
	}
	// MB
	if (size > (boundary /= 1024)) {
		return round(size / boundary, 1) + 'MB';
	}
	// KB
	if (size > 1024) {
		return Math.round(size / 1024) + 'KB';
	}
	return size + 'B';
};

const setPageTitle = (title) => {
	document.title = title || '多动屏';
};

/**
 * 校验token 是否在有效期内
 * @returns boolean
 */
const checkIfTokenValid = () => {
	const currentTime = Date.now();
	const storedTimeStamp = getStorage(LOGIN_TIME_STAMP);
	const expiredTime = getStorage(EXPIRED_TIME) || 7200;
	return currentTime - storedTimeStamp < expiredTime * 1000;
};

export {
	setStorage,
	getStorage,
	removeStorage,
	clearStorage,
	getFileSize,
	setPageTitle,
	checkIfTokenValid,
	setFirstInUrl,
	getConfigUrl,
};
